//Custom components
import Card from "../../UI/Card";
import PieChart from "../../UI/Charts/PieChart";
import WidgetLayout from "../WidgetLayout";

//Services
import { useDashboardData } from "../../../hooks/ReactQueryHooks/useDashboardQuery";

//Assets and miscellaneous
import { DashboardType } from "../../../types/Analytics";
import { transformProjectTypeChartDataSets } from "../../../utils";
import { Widget } from "../constants";

export interface ProjectTypeProps {
  projectType: string;
  _count: number;
  units: number;
}

export default function ProjectTypeWidget({
  dashboard,
}: {
  dashboard: DashboardType;
}) {
  const fetchProjectTypeWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_PROJECT_TYPE,
  });
  const projectTypeWidgetData = fetchProjectTypeWidgetData?.data?.data;
  const projectType = projectTypeWidgetData?.map(
    (data: ProjectTypeProps) => data?.projectType
  );

  const projectsByProjectType = projectTypeWidgetData?.map(
    (data: ProjectTypeProps) => {
      return { type: data?.projectType, count: data?._count };
    }
  );

  const totalProjectType = projectTypeWidgetData?.reduce(
    (acc: number, data: ProjectTypeProps) => {
      return (acc += data?._count);
    },
    0
  );

  return (
    <>
      {projectTypeWidgetData && (
        <WidgetLayout
          dashboard={dashboard}
          widget={Widget.PROJECTS_BY_PROJECT_TYPE}
        >
          <Card
            title="Projects By Development Type"
            error={fetchProjectTypeWidgetData.isError}
          >
            <div className="relative p-5 h-80">
              <div className="absolute px-5 text-center">
                <h3 className="text-gray-500 font-bold">Total Projects</h3>
                <h1 className="m-0">{totalProjectType}</h1>
              </div>
              <div className="md:w-7/8 xl:w-full h-full">
                <PieChart
                  labels={projectType}
                  datasets={transformProjectTypeChartDataSets(
                    projectsByProjectType
                  )}
                  chartTitle="Total Project Types"
                />
              </div>
            </div>
          </Card>
        </WidgetLayout>
      )}
    </>
  );
}
